import axios from "axios";
import { api_url } from "../../config";
import { AUTH_TYPES } from "../reducers/authReducers";
import tools from "../../helpers/tools";
import jwt_decode from "jwt-decode";
import { ERROR_TYPES } from "../reducers/errorReducers";

export const authActions = (state, dispatch) => {
  // `options.silencieux` : la page de connexion affiche les erreurs dans sa
  // carte, sans notification en double.
  function loginUser(userData, options = {}) {
    // fetch api
    axios
      .post(api_url + "auth/login/APP", userData)
      .then((res) => {
        // Save to localStorage
        const token = res.data;
        // Set token to ls
        localStorage.setItem("jwtToken", token);
        // Set token to Auth header
        //tools.setAuthToken(token);
        // Set current user

        dispatch({
          type: AUTH_TYPES.SET_CURRENT_USER,
          payload: jwt_decode(token),
        });
      })
      .catch((err) => {
        tools.filterError(err, dispatch, AUTH_TYPES.LOAD_CURRENT_USER, {
          silencieux: !!options.silencieux,
        });
      });
  }

  function logoutUser() {
    // Remove token from localStorage
    localStorage.removeItem("jwtToken");
    // Remove auth header for future requests
    //tools.setAuthToken(false);
    axios.get(api_url + "auth/logout");
    // Set current user to {} which will set isAuthenticated to false
    dispatch({ type: AUTH_TYPES.CLEAR_CURRENT_USER, payload: {} });
    dispatch({ type: ERROR_TYPES.CLEAR_ERRORS, payload: {} });

    //tools.filterAlert("info", "Vous avez été correctement déconnecté.");
  }

  return {
    loginUser,
    logoutUser,
  };
};
